<script lang="ts" generics="T extends string">
  interface Props {
    invalids: Record<T, { invalid: boolean; reason: string }>
    field: T
  }

  const { invalids, field }: Props = $props()
</script>

<div data-popup={`invalid${field}Hover`} class="z-50 min-w-40">
  {#if invalids[field]?.invalid}
    <div class="variant-filled-error arrow"></div>
    <div class="card variant-filled-error z-50 max-w-80 p-2">
      <p>{invalids[field].reason}</p>
    </div>
  {/if}
</div>
